import { useTranslation } from 'react-i18next';

import { PlusIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { useModal } from '@/components/modals/new/use-modal';
import { AddEmployeeModal } from './modals/add-employee-modal';

export const AddEmployeeButton = ({ tenantId }: { tenantId: string }) => {
  const { t } = useTranslation();
  const modal = useModal();

  return (
    <>
      <Button variant="outline" onClick={modal.open}>
        <PlusIcon aria-hidden />
        <span className="sr-only md:not-sr-only">{t('add-team-member')}</span>
      </Button>
      <AddEmployeeModal tenantId={tenantId} modal={modal} />
    </>
  );
};
